import React from 'react';

import FinancingRedirect from 'Modules/lendFlow/routes/FinancingRedirect';
import HomeScreen from 'Modules/lendFlow/routes/HomeScreen';
import CreateApplication from './routes/CreateApplication';

export const lendFlowHomePath = '/financing-lendflow/home';
export const createFinancingPath = '/financing-lendflow/financing';
export const createLendFlowApplicationPath = '/financing-lendflow/create-application';

export const routes = [
  { path: lendFlowHomePath, element: <HomeScreen /> },
  { path: createFinancingPath, element: <FinancingRedirect /> },
  { path: createLendFlowApplicationPath, element: <CreateApplication /> },
];
